"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var locale = {
  placeholder: 'Select time'
};
var _default = locale;
exports.default = _default;